import { router } from '@inertiajs/react'
import { MailCheck } from 'lucide-react'
import { useFlash } from '@/components/Layout'
import CreatorShell from '@/components/explore/CreatorShell'
import type { CityOption } from '@/types/publicSchool'

interface Props {
  /** E-mail para onde o link foi — vem da session, some se a pessoa cair aqui direto. */
  email: string | null
  cities: CityOption[]
}

/**
 * Pós-cadastro do criador de página: a conta existe, mas só entra depois de
 * clicar no link enviado por e-mail (Explore::EmailVerificationsController#show,
 * que verifica e já loga).
 */
export default function ConfirmEmail({ email, cities }: Props) {
  const { notice } = useFlash()

  return (
    <CreatorShell
      title="Confirme seu e-mail — BeWave Explore"
      cities={cities}
      actions={null}
      backdrop
    >
      <div className="flex flex-1 items-center justify-center px-5 py-20 sm:px-6">
        {/* Cartão branco pelo mesmo motivo do CreatorAuth: solto, o texto cai em
            cima do letreiro da ilustração de fundo. */}
        <div className="flex max-w-md flex-col items-center rounded-2xl border border-gray-200 bg-white p-6 text-center shadow-sm sm:p-8">
          <div className="flex size-14 items-center justify-center rounded-2xl bg-primary/10 text-primary">
            <MailCheck
              className="size-7"
              strokeWidth={1.75}
              aria-hidden="true"
            />
          </div>

          <h1 className="mt-6 text-2xl font-extrabold tracking-tight text-gray-900 sm:text-3xl">
            Confirme seu e-mail
          </h1>

          <p className="mt-4 text-base leading-relaxed text-gray-600">
            Enviamos um link de confirmação
            {email ? (
              <>
                {' '}
                para <strong className="text-gray-900">{email}</strong>
              </>
            ) : (
              ' para o seu e-mail'
            )}
            . Clique nele para ativar sua conta — você já entra direto.
          </p>

          {notice && (
            <p className="mt-4 rounded-lg bg-emerald-50 px-4 py-2 text-sm text-emerald-700">
              {notice}
            </p>
          )}

          <button
            type="button"
            onClick={() => router.post('/confirme-email', { email })}
            className="mt-8 inline-flex w-fit items-center gap-2 rounded-full border border-gray-300 bg-white px-6 py-3 text-sm font-semibold text-gray-800 transition-colors hover:bg-gray-50"
          >
            Reenviar e-mail
          </button>

          <p className="mt-4 text-sm text-gray-500">
            Não chegou? Olhe também a caixa de spam.
          </p>
        </div>
      </div>
    </CreatorShell>
  )
}
